import React from 'react'
import PropTypes from 'prop-types'
import PhotoswipeLink from './photoswipe_link'
import store from 'stores/photoswipe_store'

const MAX_SIZE = 3

// Single link to a gallery of images
export default class PhotoswipeGalleryLink extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
      thumbUrl: PropTypes.string,
      galleryId: PropTypes.string,
      position: PropTypes.number,
      w: PropTypes.number,
      h: PropTypes.number,
    })).isRequired,
    img_alt: PropTypes.string,
    galleryId: PropTypes.string,
    variant: PropTypes.oneOf(['card']),
    cardImageUrl: PropTypes.string,
  }

  UNSAFE_componentWillMount () {
    this.items = []
    if (this.props.variant === 'card') {
      // the card variant renders a single image itself, so every photo has to be registered here
      this.props.images.forEach( image => this.items.push(store.addImage(image)) )
      return
    }
    this.props.images.forEach( (image, idx) => {
      // we should add manually images to store, which are not rendered through PhotoswipeLink
      if (idx > MAX_SIZE - 1) {
        this.items.push(store.addImage(image))
      }
    })
  }

  componentWillUnmount () {
    const galleryId = this.galleryId()
    this.items.forEach( item => store.removeImage(item, galleryId) )
  }

  handleCardClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    store.openPhotoswipe(this.items[0], this.galleryId())
  }

  galleryId () {
    const firstImage = this.props.images[0]
    return this.props.galleryId || (firstImage && firstImage.galleryId) || 'default'
  }

  renderCard () {
    const { images, cardImageUrl, img_alt: imgAlt } = this.props
    if (images.length === 0) return null

    return (
      <a className="element-card-gallery-link" href={images[0].src} onClick={this.handleCardClick}>
        <img src={cardImageUrl || images[0].thumbUrl} alt={imgAlt} className="element-card-thumb" loading="lazy" />
        {images.length > 1 &&
          <span className="badge badge-dark element-card-photo-count">+{images.length - 1}</span>
        }
      </a>
    )
  }

  render () {
    const { images, variant } = this.props
    if (variant === 'card') return this.renderCard()

    return (
      <div className="position-relative">
        {images.slice(0, MAX_SIZE).reverse().map((image, index) =>
          <PhotoswipeLink preview key={index} {...image} style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
            <img src={image.thumbUrl} alt={this.props.img_alt} />
          </PhotoswipeLink>
        )}
      </div>
    )
  }
}
